<template>
  <div id="wc-tabbar-cart">
    <!-- <div class="van-tabbar-item"> -->
    <!-- <van-icon name="shopping-cart" slot="right" :info="cartCount" /> -->
    <!-- <div class="van-tabbar-item__icon" @click="onClickShoppingCart">
      <img :src="$defaultShoppingCartImage" />
      <div class="van-info">{{ cartCount }}</div>
    </div>-->
    <v-badge :value="cartCount" :content="cartCount" offset-y="8.88">
      <v-icon @click="onClickShoppingCart" size="28px">
        mdi-cart-outline
      </v-icon>
    </v-badge>
    <!-- <div class="van-tabbar-item__text"></div> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  //name: 'wc-tabbar-cart',
  data() {
    return {};
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    cartCount() {
      return this.$store.state.cartCount;
    },
  },
  activated() {
    // console.log('cart activated');
  },
  mounted() {
    // console.log('cart mounted');

    let token1 = this.member.SessionToken;
    let token2 = localStorage.getItem("SessionToken");
    if (token1 && token2) {
      if (token1 == token2) {
        this.getCartQtyCount();
        //this.getCartItemCount();
      } else {
        this.getMemberInfo(token2);
      }
    } else if (token1) {
      this.getMemberInfo(token1);
    } else if (token2) {
      this.getMemberInfo(token2);
    } else {
      this.$store.commit("cartCount", 0);
    }
  },

  methods: {
    // ------------------------------------------------------------------------ getMemberInfo
    getMemberInfo(token) {
      let obj = { AppVersion: this.$version, SessionToken: token };
      if (this.member.SessionId) {
        obj.SessionId = this.member.SessionId;
      }
      this.$ajax2
        .post("GetMember", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.$store.commit("member", rpdata.data.data);
            this.getCartQtyCount();
          } else {
            this.$store.commit("member", {});
          }
        })
        .catch((err) => {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getCartQtyCount
    getCartQtyCount() {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
      };
      this.$ajax2
        .post("GetCartQtyCount", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.$store.commit("cartCount", rpdata.data.data.count);
          } else {
            this.$store.commit("cartCount", 0);
          }
        })
        .catch((err) => {});
    },
    // ------------------------------------------------------------------------ getCartItemCount
    getCartItemCount() {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
      };
      this.$ajax2
        .post("GetCartItemCount", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == 200) {
            this.$store.commit("cartCount", rpdata.data.data.count);
          } else {
            this.$store.commit("cartCount", 0);
          }
        })
        .catch((err) => {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickShoppingCart
    onClickShoppingCart() {
      this.$router.push({ name: "shoppingCart" });
    },
  },
};
</script>
